__webpack_require__.p = "/Frontend-Mentor-Solutions/Results%20summary%20component/build/";